import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import {
    AI_GRADIENT_GREEN_SOFT,
    WHITE_LINEAR_GRADIENT,
} from "app/pages/sales-intelligence/modules/ai-agent/components/styles";

export const StyledTextfieldWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 114px;
    display: flex;
    align-items: flex-end;
`;

export const StyledActionWrapper = styled.div`
    position: absolute;
    right: 1px;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

export const StyledTextfield = styled.textarea<{
    $isLocked: boolean;
    $isDisabled: boolean;
    $hasAction?: boolean;
}>`
    ${setFontVariant("input2", colorsPalettes.carbon[400])}

    width: 100%;
    height: 100%;
    min-height: 40px;
    max-height: 114px;
    padding: 10px ${({ $hasAction }) => ($hasAction ? "44px" : "20px")} 10px 20px;
    margin: 0;
    field-sizing: content;

    border: 1px solid transparent;
    border-radius: 20px;
    box-shadow: none;

    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-image: ${WHITE_LINEAR_GRADIENT}, ${AI_GRADIENT_GREEN_SOFT};

    box-sizing: border-box;

    resize: none;
    overflow-y: auto;

    &::placeholder {
        color: ${colorsPalettes.carbon[200]};
    }

    ${({ $isLocked }) =>
        $isLocked &&
        css`
            background-color: ${colorsPalettes.bluegrey[200]} !important;
            color: ${colorsPalettes.midnight[100]} !important;
            cursor: default !important;
        `}

    ${({ $isDisabled }) =>
        $isDisabled &&
        css`
            background-image: none;
            background-color: ${colorsPalettes.carbon[25]};
            border: 1px solid ${colorsPalettes.carbon[100]};
            cursor: not-allowed;
        `}
`;
